export const NotificationsTypes = {
    SUCCESS: {
        name : 'SUCCESS',
        timer: 2500
    },
    ERROR  : {
        name : 'ERROR',
        timer: 7000
    },
    WARNING: {
        name : 'WARNING',
        timer: 3500
    }
};


// WEBPACK FOOTER //
// ./src/constants/notificationsTypes.js